import React, { useState } from 'react';
import SubNavbar from '../../components/SubNavbar';
import PhotoModal from '../../components/PhotoModal';

const BayArea = () => {
  const [modalImage, setModalImage] = useState(null);
  const [modalAlt, setModalAlt] = useState('');

  const openModal = (imageSrc, imageAlt) => {
    setModalImage(imageSrc);
    setModalAlt(imageAlt);
  };

  const closeModal = () => {
    setModalImage(null);
    setModalAlt('');
  };

  return (
    <div className="white-page">
      <SubNavbar />      
      <div className="photography-subpage-content">
        <div className="photos-container">
          <div className="photo-grid">
            <div className="photo-item large">
              <img 
                src="/photos/PBStorm_5000.jpg" 
                loading="lazy" 
                onClick={() => openModal("/photos/PBStorm_5000.jpg", "Storm at Panther Bay")}
                style={{ cursor: 'pointer' }}
              />
            </div>
            <div className="photo-item">
              <img 
                src="/photos/PantherBayTop_5000.jpg" 
                loading="lazy" 
                onClick={() => openModal("/photos/PantherBayTop_5000.jpg", "Panther Bay Top View")}
                style={{ cursor: 'pointer' }}
              />
            </div>
            <div className="photo-item">
              <img 
                src="/photos/DeerGunValley_1_5000.jpg" 
                loading="lazy" 
                onClick={() => openModal("/photos/DeerGunValley_1_5000.jpg", "Deer Gun Valley")}
                style={{ cursor: 'pointer' }}
              />
            </div>
            <div className="photo-item">
              <img 
                src="/photos/StreetAsheville_5000.jpg" 
                loading="lazy" 
                onClick={() => openModal("/photos/StreetAsheville_5000.jpg", "Street in Asheville")}
                style={{ cursor: 'pointer' }}
              />
            </div>
            <div className="photo-item">
              <img 
                src="/photos/Copy_of_0713822_0713822-R1-078-37A_1_5000.jpg" 
                loading="lazy" 
                onClick={() => openModal("/photos/Copy_of_0713822_0713822-R1-078-37A_1_5000.jpg", "Copy of 0713822")}
                style={{ cursor: 'pointer' }}
              />
            </div>
            <div className="photo-item">
              <img 
                src="/photos/Hills_5000.jpg" 
                loading="lazy" 
                onClick={() => openModal("/photos/Hills_5000.jpg", "Hills Landscape")}
                style={{ cursor: 'pointer' }}
              />
            </div>
            <div className="photo-item large">
              <img 
                src="/photos/SFForest_5000.jpg" 
                loading="lazy" 
                onClick={() => openModal("/photos/SFForest_5000.jpg", "San Francisco Forest")}
                style={{ cursor: 'pointer' }}
              />
            </div>
            <div className="photo-item">
              <img 
                src="/photos/GoldenGate.png" 
                loading="lazy" 
                onClick={() => openModal("/photos/PBBeach_5000.jpg", "Panther Bay Beach")}
                style={{ cursor: 'pointer' }}
              />
            </div>
            <div className="photo-item">
              <img 
                src="/photos/PBBeach_5000.jpg" 
                loading="lazy" 
                onClick={() => openModal("/photos/PBBeach_5000.jpg", "Panther Bay Beach")}
                style={{ cursor: 'pointer' }}
              />
            </div>
            <div className="photo-item">
              <img 
                src="/photos/OnTheRocks_5000.jpg" 
                loading="lazy" 
                onClick={() => openModal("/photos/OnTheRocks_5000.jpg", "On The Rocks")}
                style={{ cursor: 'pointer' }}
              />
            </div>

            <div className="photo-item">
              <img 
                src="/photos/PantherBayEntrance_5000.jpg" 
                loading="lazy" 
                onClick={() => openModal("/photos/PantherBayEntrance_5000.jpg", "Panther Bay Entrance")}
                style={{ cursor: 'pointer' }}
              />
            </div>
            <div className="photo-item">
              <img 
                src="/photos/SantacruzRight_5000.jpg" 
                loading="lazy" 
                onClick={() => openModal("/photos/SantacruzRight_5000.jpg", "Santa Cruz Right View")}
                style={{ cursor: 'pointer' }}
              />
            </div>

            <div className="photo-item">
              <img 
                src="/photos/PBBroken_5000.jpg" 
                loading="lazy" 
                onClick={() => openModal("/photos/PBBroken_5000.jpg", "Broken View at Panther Bay")}
                style={{ cursor: 'pointer' }}
              />
            </div>
            <div className="photo-item large">
              <img 
                src="/photos/RiverwalkChicago_5000.jpg" 
                loading="lazy" 
                onClick={() => openModal("/photos/RiverwalkChicago_5000.jpg", "Chicago Riverwalk")}
                style={{ cursor: 'pointer' }}
              />
            </div>


            <div className="photo-item">
              <img 
                src="/photos/SantacruzLeft_5000.jpg" 
                loading="lazy" 
                onClick={() => openModal("/photos/SantacruzLeft_5000.jpg", "Santa Cruz Left View")}
                style={{ cursor: 'pointer' }}
              />
            </div>


          </div>
        </div>
      </div>
      <PhotoModal 
        isOpen={modalImage !== null}
        imageSrc={modalImage}
        imageAlt={modalAlt}
        onClose={closeModal}
      />
    </div>
  );
};

export default BayArea;
